import { FC } from 'react';

import { Card, Tag, Typography } from '@cfa/react-components';

import { colorTag } from '@/utils/formatDocumentTag';

import Constants from 'constants/index';

interface DocumentIconProps {
  icon?: string;
  name: string;
}

const DocumentIcon: FC<DocumentIconProps> = ({ icon = '', name }) => (
  <img
    className="mr-2.5 flex w-10 min-w-10 rounded-none p-px"
    alt={name}
    src={`${Constants.PATHWAY_CDN_IMG.PROCEDURES}${
      !icon || icon === 'placeholder' ? 'Chickfila' : icon
    }.svg`}
  />
);

interface DocumentCardProps {
  icon?: string;
  name: string;
  onClick: () => void;
  tags?: string[];
  country?: string;
}

const ChooseDocumentCard: FC<DocumentCardProps> = ({
  icon = '',
  name,
  onClick,
  tags = [],
  country,
}) => (
  <Card
    elevation={1}
    onClick={onClick}
    title={name}
    variant="default"
    className="border-grayscale-gray2! my-4! w-full! flex-row! items-center! border! p-4!"
  >
    <DocumentIcon icon={icon} name={name} />
    <Typography variant="body1" className="text-primary-navy-blue!">
      {name}
    </Typography>
    {!!tags.length &&
      tags.map((tag, index) => (
        <Tag
          className="ml-2.5!"
          color={colorTag(tag)}
          key={index}
          label={tag}
          variant="filled"
        />
      ))}
    {country && (
      <Tag
        className="ml-2.5!"
        color="secondaryBlue"
        key={country}
        label={country}
        variant="outlined"
      />
    )}
  </Card>
);

export default ChooseDocumentCard;
